<template>
  <div class="sales-figure-wrapper">
    <div class="flex flex-wrap justify-between">
      <div class="text-center">
        <div class="figure-block figure-contract px-6 pb-8 pt-10 text-7xl leading-none font-extrabold flex items-end justify-center text-white rounded-xl">
          <AnimatedNumber :value="salesFigures.sumContract" style="line-height: 0.7"
            :round="true"
            :delay="1000"
            :duration="1500"
            :formatValue="formatValue"
            easing="easeInOutQuart" />
            <span v-if="isTooBig(salesFigures.sumContract)" class="uppercase text-3xl">k</span>
        </div>
        <p class="text-3xl uppercase font-extrabold py-1 text-blue-900">Hợp đồng</p>
      </div>
      <div class="text-center">
        <div class="figure-block figure-project px-6 pb-8 pt-10 text-7xl leading-none font-extrabold flex items-end justify-center text-white rounded-xl">
          <AnimatedNumber :value="salesFigures.sumProject" style="line-height: 0.7"
            :round="true"
            :delay="1250"
            :duration="1500"
            :formatValue="formatValue"
            easing="easeInOutQuart" />
            <span v-if="isTooBig(salesFigures.sumProject)" class="uppercase text-3xl">k</span>
        </div>
        <p class="text-3xl uppercase font-extrabold py-1 text-blue-900">Dự án</p>
      </div>
      <div class="text-center">
        <div class="figure-block figure-product-projector px-6 pb-8 pt-10 text-7xl leading-none font-extrabold flex items-end justify-center text-white rounded-xl">
          <AnimatedNumber :value="salesFigures.sumProductProjector" style="line-height: 0.7"
            :round="true"
            :delay="1500"
            :duration="1500"
            :formatValue="formatValue"
            easing="easeInOutQuart" />
            <span v-if="isTooBig(salesFigures.sumProductProjector)" class="uppercase text-3xl">k</span>
        </div>
        <p class="text-3xl uppercase font-extrabold pt-1 text-blue-900">Máy chiếu</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AnimatedNumber from "animated-number-vue"

export default {
  components: {
    AnimatedNumber
  },
  mounted() {
  },
  methods: {
    isTooBig(val) {
      return val > 9999
    },
    formatValue(value) {
      if(this.isTooBig(value)) {
        return parseInt(value / 1000)
      }
      return value
    }
  },
  computed: {
    ...mapGetters([
      'salesFigures'
    ]),
  }
}
</script>

<style>
.sales-figure-wrapper {
  --bg-block-contract: #5cc6c1;
  --bg-block-project: #00aeef;
  --bg-block-product-projector: #7997d3;
}
.figure-block {
  min-width: 12.5rem;
}
.figure-block * {
  line-height: 1;
}
.figure-contract {
  background-color: var(--bg-block-contract);
}
.figure-project {
  background-color: var(--bg-block-project);
}
.figure-product-projector {
  background-color: var(--bg-block-product-projector);
}
</style>